import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";

export const Wrapper = styled.div`
    margin-left: ${globalStyles.desktop.pageMargin};
    margin-right: ${globalStyles.desktop.pageMargin};

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        margin-left: ${globalStyles.mobile.pageMargin};
        margin-right: ${globalStyles.mobile.pageMargin};
    }
`